import ImgSlide from './goods/imgslide.es6';

const slide = new ImgSlide();